import { Component, Input, OnInit } from "@angular/core";

import Geolocation from 'ol/Geolocation.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import Feature from 'ol/Feature.js';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';
import Point from 'ol/geom/Point.js';

@Component({
    selector: 'gis-geolocation',
    templateUrl: './geolocation.component.html',
    styleUrls: ['./geolocation.component.scss'],
})
export class GeolocationComponent implements OnInit {
    @Input()
    set map(data) {    
        if (!(this._map) && data){           
            this._map = data;
            this.initGeolocation();                    
        }    
    }
    get map(){
        return this._map
    }

    _map: any;    
    positionFeature: any;
    geolocation: any;
    enabledGeolocation = false;
    firstGeolocation = false;

    constructor() { }

    ngOnInit() {}

    initGeolocation(){
        this.createGeolocationLayer();        
        this.geolocation = new Geolocation({
            // take the projection to use from the map's view
            trackingOptions: {
                enableHighAccuracy: true,
            },
            projection: this._map.getView().getProjection()
        });        
    }

    createGeolocationLayer(){
        this.positionFeature = new Feature();
        this.positionFeature.setStyle(
            new Style({
                image: new CircleStyle({
                    radius: 6,
                    fill: new Fill({
                        color: '#3399CC',
                    }),
                    stroke: new Stroke({
                        color: '#fff',
                        width: 2,
                    }),
                }),
            })
        );
        const source = new VectorSource({
            features: [this.positionFeature]          
        });

        const vector = new VectorLayer({            
            source: source,
            zIndex: 2
        });
        this._map.addLayer(vector)
    }

    onClick(){
        if (!this.enabledGeolocation){
            this.enableGeolocation();
            this.enabledGeolocation = true;
        } else {
            this.zoomToLayer();
        }
    }

    enableGeolocation(){         
        this.firstGeolocation = true;
        this.geolocation.setTracking(true);        
        // listen to changes in position
        this.geolocation.on('change:position', () => {            
            const coordinates = this.geolocation.getPosition();                        
            this.positionFeature.setGeometry(coordinates ? new Point(coordinates) : null)
            if (coordinates && this.firstGeolocation){
                this.zoomToLayer();
                this.firstGeolocation = false;
            }
        });        
    }

    zoomToLayer(){   
        this._map.getView().fit(this.positionFeature.getGeometry(), {maxZoom: 17, duration: 1500});
    }
}